<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h2 class="h2"><a id="page_ix"></a><a id="frontmatter02"></a>Acknowledgments</h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><big>I</big> will always have to give special recognition to the members of my Street Team, who have my back, keep the energy high, and keep joy and laughter a part of this whole experience. <em>Thank you</em> sooo much! I couldn’t do it without you, gang! This time around, special thanks to Alicia, who went through a really rough period with me—always sending me uplifting reading material, pastoral words, and beautiful cards of hope just to keep my inner hope and inspiration burning bright. Bless you, lady. Then there’s “The Mod Squad,” LOL . . . Manie, Monique, and Colleen, with support from the rest of the St. Martin’s dream team. Thank you all for “making it do what it do!” And Iola, who knows how special she is on so many levels that I cannot even begin to explain it. Last but never least is my sister, Liza, and my daughter, Helena . . . I love you. Family. Thank you all!</p>
<p class="para"> </p>
<p class="para"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?6448d990